export default {
  title: 'Produits mis en avant',
};
